import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PERMISSIONS_FEATURE_KEY, PermissionsState } from './permissions.reducer';

export const state = createFeatureSelector<PermissionsState>(PERMISSIONS_FEATURE_KEY);
export const selectPushNotificationToken = createSelector(state, (state: PermissionsState) => {
    return state.pushNotificationToken;
});
export const selectNotificationsChanel = createSelector(state, (state: PermissionsState) => state.channels);
export const selectListenersAdded = createSelector(state, (state: PermissionsState) => state.listenersAdded);
export const selectIsNativeApp = createSelector(state, (state: PermissionsState) => state.isNativeApp);
